import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core'
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { ModalService } from '@app/modal/modal.service'
import { TermosGeraisService } from '../../service/geral/termos-gerais.service'

@Component({
  selector: 'app-termos-gerais',
  templateUrl: './termos-gerais.component.html',
})
export class TermosGeraisComponent implements AfterViewInit {
  constructor(private modalService: ModalService, private confirmacaoService: TermosGeraisService) {}

  @ViewChild('modal') component: TemplateRef<any>
  private modal: MatDialogRef<any>

  ngAfterViewInit(): void {
    this.confirmacaoService.getAceito().subscribe((aceito) => aceito || this.openModal())
  }

  openModal(): void {
    let dialogConfig = new MatDialogConfig()
    dialogConfig.width = '22em'
    dialogConfig.disableClose = true
    this.modal = this.modalService.openCustomComponentModal(this.component, dialogConfig)
  }

  onSubmit(): void {
    this.confirmacaoService.saveAceitouTermos().subscribe(() => this.closeModal())
  }

  private closeModal(): void {
    this.modal.close()
  }
}
